module.exports = __webpack_public_path__ + "static/media/banner.c073b1be.jpg";